'use client';

import { useState } from 'react';
import { PHONE, PHONE_DISPLAY, EMAIL, WHATSAPP_LINK } from '@/config/constants';
import { IconPhoneContact, IconWhatsAppContact, IconEmailContact } from './DesignIcons';

export default function ContactModal({ isOpen, onClose }) {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    category: 'Individuals',
    message: '',
  });

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    // WhatsApp direct message option
    const text = encodeURIComponent(
      `Hello InnerTruth, I am ${formData.name}. I would like to enquire about ${formData.category} sessions. My phone is ${formData.phone}.`
    );
    window.open(`${WHATSAPP_LINK}?text=${text}`, '_blank');
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="modal-close-btn" onClick={onClose} aria-label="Close dialog">
          ✕
        </button>

        <div className="modal-header">
          <span className="modal-tag">START YOUR JOURNEY</span>
          <h3 className="modal-title">Connect with InnerTruth</h3>
          <p className="modal-subtitle">
            Take the first step toward self-mastery and emotional excellence.
          </p>
        </div>

        {/* Quick Contact Options */}
        <div className="quick-contact-row">
          <a href={`tel:${PHONE}`} className="quick-badge">
            <span className="badge-icon phone-bg"><IconPhoneContact size={16} /></span>
            <span>{PHONE_DISPLAY}</span>
          </a>
          <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="quick-badge">
            <span className="badge-icon wa-bg"><IconWhatsAppContact size={16} /></span>
            <span>WhatsApp</span>
          </a>
          <a href={`mailto:${EMAIL}`} className="quick-badge">
            <span className="badge-icon email-bg"><IconEmailContact size={16} /></span>
            <span>{EMAIL}</span>
          </a>
        </div>

        {submitted ? (
          <div className="modal-success">
            <div className="success-icon">✓</div>
            <h4>Thank You for Reaching Out!</h4>
            <p>We are opening WhatsApp to connect directly with Dr. (H.C.) Shyam Kumar.</p>
            <button type="button" className="btn-modal-submit" onClick={onClose}>
              Close
            </button>
          </div>
        ) : (
          <form className="modal-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="modal-name">Your Full Name</label>
              <input
                id="modal-name"
                type="text"
                required
                placeholder="Enter your name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="modal-phone">Phone / WhatsApp</label>
                <input
                  id="modal-phone"
                  type="tel"
                  required
                  placeholder="+91 XXXXX XXXXX"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                />
              </div>

              <div className="form-group">
                <label htmlFor="modal-cat">Program of Interest</label>
                <select
                  id="modal-cat"
                  value={formData.category}
                  onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                >
                  <option value="Individuals">Individuals (Personal Clarity)</option>
                  <option value="Schools">Schools (Life Skills)</option>
                  <option value="Colleges">Colleges (Youth Confidence)</option>
                  <option value="Parents & Families">Parents & Families</option>
                  <option value="Corporates">Corporates (High-Performing Teams)</option>
                  <option value="Groups">Groups (Real Change)</option>
                  <option value="The Book">The Book: 6 Steps</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="modal-msg">How can we support you?</label>
              <textarea
                id="modal-msg"
                rows="3"
                placeholder="Tell us what you are looking to transform..."
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              ></textarea>
            </div>

            <button type="submit" className="btn-modal-submit">
              Connect on WhatsApp →
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
